.heading {
  color: var(--color-text);
  font-family: var(--font-family-heading);
}

.alignCenter {
  text-align: center;
}

.color_default,
.color_text {
  color: var(--color-text);
}

.color_primary {
  color: var(--color-primary);
}

.color_muted {
  color: var(--color-text-muted);
}

.color_onPrimary {
  color: var(--color-text-on-primary);
}

.color_inherit {
  color: inherit;
}

.h1 {
  font-size: 2.5rem;
  font-weight: 400;
  margin: 1.75rem 0;
}

.h1_compactBottom {
  margin-bottom: 1rem;
}

.h1_responderTitle {
  font-size: 2.125rem;
}

.h1_journeyCard {
  font-size: 34px;
  line-height: 1.1;
  margin: 0;
}

.h2 {
  font-size: 2rem;
  font-weight: 400;
  margin: 1.75rem 0;
}

.h2_compact {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

.h2_journeyCard {
  font-family: var(--font-family-heading);
  font-size: 20px;
  font-weight: 400;
  margin: 4px 0 0;
}

.h3 {
  color: var(--color-text);
  font-size: var(--font-size-large);
  font-weight: 500;
  margin: 1.75rem 0 0.5rem;
}

.h3_noTop {
  margin-top: 0;
}

.h3_compact {
  margin-top: 0;
  margin-bottom: 0.25rem;
}

.h3_flush {
  margin: 0;
  padding: 0;
}

.h3_dense {
  margin: 0.5rem 0;
}

.h3_section {
  margin-top: 2rem;
}

.h3_spaced {
  flex: 1 1 auto;
  margin: 1rem 0;
}

.h3_noTopDense {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

.h3_journeyCard {
  color: inherit;
  font-family: var(--font-family-base);
  font-size: 13px;
  font-weight: 400;
  margin: 6px 0 0;
  opacity: 0.75;
}

.h4 {
  font-size: 1rem;
  font-weight: 500;
  margin: 0.375rem 0;
}

.h4_flush {
  margin: 0;
}

.h4_messageItem,
.h3_messageItem {
  margin-top: 0.5rem;
  overflow: hidden;
}

.h5 {
  font-size: 1.563rem;
  font-weight: 400;
  margin: 0.25rem 0;
}

.h6 {
  font-size: 1.25rem;
  font-weight: 400;
  margin: 0.125rem 0;
}
